import { cn } from '@/lib/utils';

interface SaveBarProps {
  show: boolean;
  saving: boolean;
  onDiscard: () => void;
  onSave: () => void;
}

/**
 * The floating "unsaved changes" pill (OG `.v16-save-bar`). Fixed bottom-center,
 * slides up + fades in when the draft is dirty, slides away otherwise.
 */
export function SaveBar({ show, saving, onDiscard, onSave }: SaveBarProps) {
  return (
    <div
      className={cn(
        'fixed bottom-6 left-1/2 z-[120] flex -translate-x-1/2 items-center gap-3.5 rounded-pill border border-card-line bg-[rgba(15,15,18,0.92)] py-2.5 pl-[18px] pr-3.5 shadow-[0_18px_40px_rgba(0,0,0,0.5)] backdrop-blur-xl transition-all duration-300 ease-cinematic',
        show ? 'translate-y-0 opacity-100' : 'pointer-events-none translate-y-[60px] opacity-0',
      )}
      role="region"
      aria-label="Unsaved changes"
    >
      <span className="text-[13px] font-semibold text-hi/90">You have unsaved changes</span>
      <button
        type="button"
        onClick={onDiscard}
        className="rounded-pill border border-white/15 px-4 py-2 text-xs font-bold text-mid transition-colors hover:border-white/30 hover:text-hi"
      >
        Discard
      </button>
      <button
        type="button"
        onClick={onSave}
        disabled={saving}
        className="rounded-pill bg-white px-4 py-2 text-xs font-bold text-black shadow-[0_4px_14px_rgba(0,0,0,0.35)] transition-transform hover:-translate-y-px disabled:cursor-not-allowed disabled:opacity-50"
      >
        {saving ? 'Saving…' : 'Save changes'}
      </button>
    </div>
  );
}
